<template>
	<div class="qa-wrapper">
		<div class="questionAndAnswers">
			<div class="title"><span class="icon"></span>问答专区</div>
			<div class="input-area">
				<el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="message"></el-input>
				<div class="publish-btn">
					<el-button type="warning" size="small" @click="publish">提问</el-button>
				</div>
			</div>
			<div>
				<div class="qa-item" v-for="item in dataList">
					<div class="question"><el-image :src="require('@/assets/softWare/Q.png')" fit="fill"></el-image><span>{{item.message}}</span></div>
					<div class="answer" v-if="item.topAnswer">{{item.topAnswer.message}}</div>
					<div class="createDate">
						<span>{{item.createDate}}</span>
						<span style="float: right;" v-if="item.answerList.length>0">{{item.answerList.length}}个回答</span>
					</div>
				</div>
				<div class="nomore">没有更多喽~</div>
			</div>
		</div>		
	</div>
</template>

<script>
import { getQAlist,likerecord,commitQA } from '@/api/software/index'
export default {
  props:['data'],
  data () {
    return {
	  message: '',
      dataList:[],
	  
    }
  },
  methods: {
	async getDataList(){
		const res = await getQAlist({softwareId:this.data.id})
		if (res.code === 0) {
			res.data.list.forEach((item)=>{
				item.createDate = new Date(item.createDate).toLocaleString()
			})
			this.dataList = res.data.list
		} else {
		  this.$message.error(res.msg)
		}
	},
	
	async QAup(){
		const res = await likerecord({dataId:this.data.id,type:'2'})
		if (res.code === 0) {
			this.$message.success('点赞成功')
		} else {
		  this.$message.error(res.msg)
		}
	},
	async publish(){
		const res = await commitQA({softwareId:this.data.id,type:'0',message:this.message,parentId: "0"})
		if (res.code === 0) {
			this.$message.success('提交成功')
			this.getDataList()
		} else {
		  this.$message.error(res.msg)
		}
	}
  },
  mounted () {
	window.scrollTo({top:0})
	this.data.id = this.$route.params.softwareId
	this.getDataList()
  }

}
</script>

<style lang="scss" scoped>
.qa-wrapper{
	.questionAndAnswers{
		background-color: #fff;
		border-radius: 8px;
		padding: 30px;
		padding-left: 35px;
		box-sizing: border-box;
		.title{
			font-size: 20px;
			font-weight: 800;
			color: #000000;
			margin-bottom: 10px;
			position: relative;
			.icon{
				position: absolute;
				top: 5px;
				left: -15px;
				display: inline-block;
				width: 6px;
				height: 20px;
				background-color: #FF8632;
				border-top-right-radius: 6px;
				border-bottom-right-radius: 6px;
			}
		}
		.input-area{
			padding:10px 0;
			border-bottom: 1px solid #D9D8D9;
			.publish-btn{
				margin: 20px 0;
				&::after{
					content: '';
					display: block;
					clear: both;
				}
				.el-button{
					float: right;
					background-color: #FF842E;
				}
			}
		}
		.qa-item{
			padding:20px 0;
			border-bottom: 1px solid #D9D8D9;
			cursor: pointer;
			.question{
				color: #404450;
				font-size: 18px;
				font-weight: 800;
				margin-bottom: 10px;
				.el-image{
					width: 25px;
					height: 25px;
					margin-right: 10px;
					vertical-align: top;
				}
				
			}
			.answer{
				background-color: #F8F9FA;
				border-radius: 8px;
				padding: 20px 28px;
				margin: 10px 0;
			}
			.createDate{
				color: #A1A7B0;
				font-size: 14px;
			}
		}
		.nomore{
			color: #A1A7B0;
			font-size: 14px;
			margin: 30px 0 10px;
			text-align: center;
		}
	}
	
}

</style>